import { render, staticRenderFns } from "./ViParentAdmission.vue?vue&type=template&id=40f8e392"
import script from "./ViParentAdmission.vue?vue&type=script&lang=js"
export * from "./ViParentAdmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports